// extracted by mini-css-extract-plugin
export default {"DialogPresenter":"DialogPresenter_DialogPresenter__tmi6l"};